import { useTranslation } from 'react-i18next';
import { ActionIcon, Group, Stack, Text } from '@mantine/core';
import { IconDownload, IconFileText } from '@tabler/icons-react';

interface OrderFileLinksProps {
  readonly files: readonly { readonly id: number; readonly name?: string }[];
  readonly onDownload: (id: number) => void;
  /** id файла, который сейчас качается — спиннер показываем только на нём. */
  readonly downloadingId?: number;
}

// Read-only список файлов заказа со скачиванием (декларация/особые условия продавца в превью сделки).
// Без удаления (в отличие от form/FileList) — контрагент только смотрит и качает.
export default function OrderFileLinks({ files, onDownload, downloadingId }: OrderFileLinksProps) {
  const { t } = useTranslation();
  if (files.length === 0) {
    return null;
  }
  return (
    <Stack gap={6}>
      {files.map((file) => (
        <Group key={file.id} gap="sm" wrap="nowrap" justify="space-between">
          <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
            <IconFileText size={18} color="var(--mantine-color-brand-6)" style={{ flexShrink: 0 }} />
            <Text size="sm" c="gray.8" truncate="end" style={{ minWidth: 0 }}>
              {file.name ?? `#${file.id}`}
            </Text>
          </Group>
          <ActionIcon
            variant="subtle"
            color="gray"
            aria-label={t('common.download')}
            loading={downloadingId === file.id}
            onClick={() => onDownload(file.id)}
            style={{ flexShrink: 0 }}
          >
            <IconDownload size={18} />
          </ActionIcon>
        </Group>
      ))}
    </Stack>
  );
}
